module.exports = __webpack_public_path__ + "img/nosotros-2.9acf6ca5.png";